'use client';

import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useStore } from '@base-ui/utils/store';
import { schedulerEventSelectors } from '@mui/x-scheduler-internals/scheduler-selectors';
import { useSchedulerStoreContext } from '@mui/x-scheduler-internals/use-scheduler-store-context';
import { getPaletteVariants } from "../../utils/tokens.mjs";
import { EventCalendarStyledContext } from "../../../event-calendar/EventCalendarStyledContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const EventDragPreviewRoot = styled('div', {
  name: 'MuiEventCalendar',
  slot: 'EventDragPreview'
})(({
  theme
}) => ({
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.spacing(0.5),
  fontSize: theme.typography.body2.fontSize,
  backgroundColor: 'var(--event-surface-bold)',
  color: 'var(--event-on-surface-bold)',
  variants: getPaletteVariants(theme)
}));
const fakeStore = {
  subscribe: () => {},
  getSnapshot: () => ({})
};
export function EventDragPreview(props) {
  const store = useSchedulerStoreContext(true);
  const styledContext = React.useContext(EventCalendarStyledContext);
  const color = useStore(store ?? fakeStore, store ? schedulerEventSelectors.color : () => 'teal', props.data.id);
  return /*#__PURE__*/_jsx(EventDragPreviewRoot, {
    className: styledContext?.classes.eventDragPreview,
    "data-palette": color,
    children: props.data.title
  });
}